import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "../../../6729.css";

import image1 from "../../../images/gear/gera-oil/8710/8710_1front.webp";
import image2 from "../../../images/gear/gera-oil/8710/8710_1back.webp";



const images = [
  { src: image1, alt: "Front" },
  { src: image2, alt: "Back" },

];

const packageSlides = [
  { images: [image1, image2] },
 

];

const TDS_URL = "https://www.fanfaro.de/create-pdf/88";


const SDS_FILES = [
  { code: "BE", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(BE).pdf" },
  { code: "BG", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(BG).pdf" },
  { code: "CZ", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(CZ).pdf" },
  { code: "DE", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(DE).pdf" },
  { code: "DK", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(DK).pdf" },
  { code: "EE", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(EE).pdf" },
  { code: "ES", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(ES).pdf" },
  { code: "FI", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(FI).pdf" },
  { code: "FR", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(FR).pdf" },
  { code: "GR", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(GR).pdf" },
  { code: "HR", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(HR).pdf" },
  { code: "HU", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(HU).pdf" },
  { code: "IE (EN)", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(IE).pdf" },
  { code: "IT", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(IT).pdf" },
  { code: "LT", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(LT).pdf" },
  { code: "LV", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(LV).pdf" },
  { code: "NO", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(NO).pdf" },
  { code: "PL", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(PL).pdf" },
  { code: "PT", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(PT).pdf" },
  { code: "RO", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(RO).pdf" },
  { code: "RU", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(RU).pdf" },
  { code: "SE", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(SE).pdf" },
  { code: "SI", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(SI).pdf" },
  { code: "SK", url: "https://sct-b2b.com/out/msds/sdFF8710_-_FANFARO 8710 MAX 7 75W-80_(SK).pdf" }
];



export default function ImageWithContent() {

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showSDS, setShowSDS] = useState(false);

  const [packageIndex, setPackageIndex] = useState(0);
  const [imageIndex, setImageIndex] = useState(0);

  const slideInterval = useRef(null);
  const slideDuration = 4000;

  useEffect(() => {
    startSlideTimer();
    return () => clearInterval(slideInterval.current);
  }, []);

  const startSlideTimer = () => {
    slideInterval.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, slideDuration);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
    clearInterval(slideInterval.current);
    startSlideTimer();
  };

  const nextImage = () => {
    const total = packageSlides[packageIndex].images.length;
    setImageIndex((prev) => (prev + 1) % total);
  };

  const prevImage = () => {
    const total = packageSlides[packageIndex].images.length;
    setImageIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
  };

  return (
   <>
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
        gap: "32px",
        padding: "24px",
        fontFamily: "Arial",
      }}
    >

      {/* LEFT IMAGE CAROUSEL */}
       <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

        {/* IMAGE CAROUSEL */}
        <div
          style={{
            position: "relative",
            width: "300px",
            height: "400px",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          {images.map((img, index) => (
            <img
              key={index}
              src={img.src}
              alt={img.alt}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                position: index === currentIndex ? "relative" : "absolute",
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
              }}
            />
          ))}
        </div>
        <p
          style={{
            // marginTop: "15px",
            fontSize: "14px",
            color: "#0c0c0c",
            textAlign: "justify",
            lineHeight: "1.6",
            width:"250px",
            fontSize:"12px"
          }}
        >
          Attention! The packaging is illustrative and may differ from its actual appearance. For the latest list of specifications, see the text section.
        </p>


        
        {/* Amazon Button (external link) */}
        <a
          href="https://www.amazon.in/FANFARO-75W-80-Synthetic-Manual-Germany/dp/B0866MR67P/ref=sr_1_1?"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <button
            style={{
              width: "150px",
              padding: "12px",
              backgroundColor: "#0d4d33",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Buy on Amazon
          </button>
        </a>

      </div>

      {/* RIGHT CONTENT */}
      <div style={{ paddingLeft: "30px", maxWidth: "850px" }}>
        <h2>FANFARO MAX 7 75W-80 8710</h2>

        <p>
      A latest-generation energy-conserving synthetic gear oil for manual transmissions. It is recommended for use in all types of 5- and 6-speed synchronized manual transmissions, including transmissions with an incorporated differential of front wheel drive vehicles, transfer cases and main gears, in which the application of the standard GL-4 is prescribed. It was developed on the basis of the requirements set by the BMW group.

        </p>

        <p><strong>Product properties:</strong></p>

        <ul style={{ paddingLeft: "20px" }}>
       <li>The low-viscosity synthetic base of the highest quality with ideal viscosity in the required range of temperatures in combination with a latest-generation additive package ensures superior antifriction properties thus ensuring a significant fuel economy and the smoothness of the transmission shift;</li>
  <li>Due to its unique composition, it ensures excellent antiwear and anti-scuffing properties that significantly extend the expected life of the technical equipment in all, even the most extreme, modes of operation in a wide range of ambient temperatures. The oil film has an increased resistance to elevated pressure;</li>
  <li>The synthetic base ensures superior low-temperature properties that ensure an easy starting, reliable lubrication, as well as an easy and precise transmission shift at the lowest (up to -30 °C) ambient temperatures;</li>
  <li>Due to the synthetic base, it has a high thermal-oxidative stability that allows increasing the time between the oil changes and reducing equipment maintenance costs;</li>
  <li>It protects metal parts from corrosion;</li>
  <li>It is compatible with sealing materials, prevents them from swelling, hardening and shrinking thus allowing the reduction of costs for spare parts;</li>
  <li>It has a reduced foam and sludge formation rate, reduces noise, it does not breakdown and preserves the structure homogeneity throughout the entire service life.</li>
        </ul> <br />

        <p>
 
It is recommended for BMW, Volvo, Toyota, Nissan, Mitsubishi, Peugeot, Honda vehicles, in which the required level of operating properties is GL-4 or lower.<br/>

     
    Comply with the manufacturer’s instructions provided in the user’s manual.
        </p>


        <p style={{ color: "#4CAF50", fontWeight: "bold" }}>
          CORRESPONDS WITH REQUIREMENTS / SPECIFICATIONS / PRODUCTS:
        </p>

        {/* SPECIFICATIONS */}
        <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
          <div>
            <b>Specifications</b>
            <ul style={{ paddingLeft: "20px" }}>
              <li>SAE 75W-80</li>
             
              
            </ul>
          </div>


          <div>
            <b>Recommendation</b>
<ul style={{ paddingLeft: "20px" }}>
  <li>API GL-4</li>
  <li>VOLKSWAGEN G 009 317</li>
  <li>VOLKSWAGEN G 052 171</li>
  <li>VOLKSWAGEN G 052 178</li>
  <li>VOLKSWAGEN G 052 512</li>
  <li>VOLKSWAGEN G 052 532</li>
  <li>VOLKSWAGEN G 052 527</li>
  <li>VOLKSWAGEN G 052 726</li>
  <li>VOLKSWAGEN G 052 798</li>
  <li>VOLKSWAGEN G 055 726</li>
  <li>BMW MTF LT-1</li>
  <li>BMW MTF LT-2</li>
  <li>BMW MTF LT-3</li>
  <li>BMW MTF LT-4</li>
  <li>FORD WSS-M2C200-D2</li>
  <li>MB 235.10</li>
  <li>MITSUBISHI MZ312644 3005401</li>
  <li>NISSAN 999MP-MTF20P KE91699932R</li>
  <li>PEUGEOT 9730 A2</li>
  <li>PEUGEOT 9730 A8</li>
  <li>PSA B71 2330</li>
  <li>TOYOTA JWS 227</li>
</ul>
          
          </div>

          <div>
            <b>PACKAGES:</b>
            <ul style={{ paddingLeft: "20px" }}>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(0);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  1L (FF8710-1)
                </span>
              </li>

              {/* <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(1);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  20L (FF6201-60)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(2);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  60L (FF6201-DR)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(3);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  208L (FF6201-IBC)
                </span>
              </li> */}

            </ul>
          </div>
          <div>
            <b>SDS & TDS</b>
            <ul style={{ paddingLeft: "20px" }}>

              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowSDS(true);
                  }}
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  📄 SDS
                </a>
              </li>

              <li>
                <a
                  href="https://www.fanfaro.de/create-pdf/88"
                  target="_blank"
                  style={{ textDecoration: "none" }}>
                  🖨️ TDS
                </a>
              </li>

            </ul>
          </div>

        </div>



      </div>

      {/* MODAL */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              width: "500px",
              borderRadius: "8px",
              position: "relative",
            }}
          >

            <span
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                right: "15px",
                top: "10px",
                cursor: "pointer",
                fontSize: "22px",
              }}
            >
              ✕
            </span>

            <img
              src={packageSlides[packageIndex].images[imageIndex]}
              alt="package"
              style={{
                width: "100%",
                maxHeight: "450px",
                objectFit: "contain",
              }}
            />

            <div style={{ textAlign: "center", marginTop: "20px" }}>

              <button onClick={prevImage}>◀</button>

              <span style={{ margin: "0 15px" }}>
                {imageIndex + 1} of {packageSlides[packageIndex].images.length}
              </span>

              <button onClick={nextImage}>▶</button>

            </div>

          </div>
        </div>
      )}

      {showSDS && (
        <div className="sds-overlay" onClick={() => setShowSDS(false)}>
          <div className="sds-modal" onClick={(e) => e.stopPropagation()}>
            {/* Close Icon */}
            <button
              className="sds-close-icon"
              onClick={() => setShowSDS(false)}
              aria-label="Close SDS"
            >
              ×
            </button>

            <h3>FANFARO M-4T Plus</h3>

            <div className="sds-grid">
              {SDS_FILES.map((file) => (
                <a
                  key={file.code}
                  href={file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {file.code}
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>

    <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
   </>
  );
}